// src/utils/markdownUtils.js
import remarkGfm from 'remark-gfm';

export const mdComponents = {
  a: ({ href, children, ...props }) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-pink-400 underline hover:text-blue-300"
      {...props}
    >
      {children}
    </a>
  ),
  strong: ({ node, ...props }) => <span className="font-bold" {...props} />,
  p: ({ node, ...props }) => <p className="mb-4" {...props} />,
  ul: ({ node, ...props }) => <ul className="mb-4 list-disc list-inside" {...props} />,
  ol: ({ node, ...props }) => <ol className="mb-4 list-decimal list-inside" {...props} />,
  h1: ({ node, ...props }) => <h1 className="text-2xl font-bold mb-4" {...props} />,
  h2: ({ node, ...props }) => <h2 className="text-xl font-bold mb-3" {...props} />,
  h3: ({ node, ...props }) => <h3 className="text-lg font-semibold mb-2" {...props} />,
  blockquote: ({ node, ...props }) => (
    <blockquote className="border-l-4 border-gray-500 pl-4 italic mb-4" {...props} />
  )
};

export const markdownConfig = {
  components: mdComponents,
  remarkPlugins: [remarkGfm]
};
